export const DEFAULT_MATCHED_TOKEN = null;
